// Libs
import React, { ReactElement } from 'react';
import clsx from 'clsx';
// App
import styles from './section.module.scss';
import { SectionProps } from './section.interfaces';

/**
 * This component is used to manage margin between sections
 * @param props the component props
 */
const Section = (props: SectionProps): ReactElement => {
  const { children, spacing, className, ...sectionPropsRest } = props;

  return (
    <section {...sectionPropsRest} className={clsx(styles[spacing || 'large'], className)}>
      {children}
    </section>
  );
};

export default Section;
